import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useState } from 'react';
import { Popup } from 'semantic-ui-react';
import { DEFAULT_ICON_COLOR, DEFAULT_ICON_LIKED, DEFAULT_ICON_UNLIKED, FEEDBACK_ERROR_MESSAGE, FEEDBACK_POPUP_DURATION } from './LikeButton.constants';
import { IconsPropType, MessagesPropType } from './LikeButton.propTypes';
import { ActionName } from '../../../../components/RecaptchaProvider/RecaptchaProvider.constants';
import useStorage from '../../../../hooks/use-storage';
import ReactionPanel from '../ReactionPanel/ReactionPanel';
import './LikeButton.css';
var defaultProps = {
  icons: {
    liked: DEFAULT_ICON_LIKED,
    unliked: DEFAULT_ICON_UNLIKED,
    color: DEFAULT_ICON_COLOR
  },
  recaptchaAction: ActionName.ANNOTATE_MENU_ITEM,
  initialLikeCount: 0,
  displayCount: true,
  messages: {
    failure: FEEDBACK_ERROR_MESSAGE
  }
};
function LikeButton(_ref) {
  var id = _ref.id,
    icons = _ref.icons,
    storageKey = _ref.storageKey,
    recaptchaAction = _ref.recaptchaAction,
    onLike = _ref.onLike,
    initialLikeCount = _ref.initialLikeCount,
    displayCount = _ref.displayCount,
    messages = _ref.messages;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    displayFeedback = _useState2[0],
    setDisplayFeedback = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    timeoutId = _useState4[0],
    setTimeoutId = _useState4[1];
  var _ref2 = icons || {},
    _ref2$liked = _ref2.liked,
    activeIcon = _ref2$liked === void 0 ? DEFAULT_ICON_LIKED : _ref2$liked,
    _ref2$unliked = _ref2.unliked,
    inactiveIcon = _ref2$unliked === void 0 ? FEEDBACK_ERROR_MESSAGE : _ref2$unliked,
    _ref2$color = _ref2.color,
    activeColor = _ref2$color === void 0 ? DEFAULT_ICON_COLOR : _ref2$color;
  var _useStorage = useStorage(storageKey, false),
    _useStorage2 = _slicedToArray(_useStorage, 3),
    liked = _useStorage2[0],
    setLiked = _useStorage2[1],
    storageLoaded = _useStorage2[2];
  var _ref3 = messages || {},
    _ref3$failure = _ref3.failure,
    failureMessage = _ref3$failure === void 0 ? FEEDBACK_ERROR_MESSAGE : _ref3$failure;
  if (!storageLoaded) {
    return null;
  }
  function onClick(_x, _x2) {
    return _onClick.apply(this, arguments);
  }
  function _onClick() {
    _onClick = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(active, recaptchaToken) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return onLike(id, active, recaptchaToken);
          case 3:
            setLiked(active);
            _context.next = 12;
            break;
          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](0);
            setDisplayFeedback(true);
            if (timeoutId) {
              clearTimeout(timeoutId);
            }
            setTimeoutId(setTimeout(function () {
              return setDisplayFeedback(false);
            }, FEEDBACK_POPUP_DURATION));
            throw _context.t0;
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 6]]);
    }));
    return _onClick.apply(this, arguments);
  }
  return /*#__PURE__*/React.createElement(Popup, {
    open: displayFeedback,
    content: failureMessage,
    position: "bottom center",
    className: "item-like-feedback error",
    offset: [0, 10],
    trigger: /*#__PURE__*/React.createElement(ReactionPanel, {
      className: "item-like-container",
      activeId: liked ? activeIcon : null
    }, /*#__PURE__*/React.createElement(ReactionPanel.ReactionIcon, {
      iconId: activeIcon,
      activeColor: activeColor,
      iconName: liked ? activeIcon : inactiveIcon,
      onClick: onClick,
      action: recaptchaAction,
      initialCount: initialLikeCount,
      displayCount: displayCount
    }))
  });
}
LikeButton.defaultProps = defaultProps;
export default LikeButton;